import { post, get } from './api';

// export const login = (email, password) => {
//   return post('/auth/login', { email, password });
// };

export const login = (data) => {
  return post("/auth/login", data); // 
};

export const forgot = (email) => {
  return post('/auth/forgot-password', { email });
};

export const verifyOtp = (email, otp ) => {
  return post('/auth/verify-otp', { email, otp });
};

export const resetPassword = (data) => {
  return post('/auth/reset-password', data);
};

export const rememberMe = (token) => {
  return get("/auth/me", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};




